import {
  Button,
  Center,
  Container,
  Flex,
  FormLabel,
  Image,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Td,
  Text,
  Tr,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import { fetch_big_files, upload_big_file } from "../../utils/apis";
import HeadingLayout from "../../components/HeadingLayout";
import TableView from "../../components/TableView";
import Loader from "../../components/Loader";
import CustomButton from "../../components/CustomButton";
import { toast } from "react-toastify";

const BigFiles = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  const [docname, setDocname] = useState("");
  const [doctype, setDoctype] = useState("");
  const [docfile, setDocfile] = useState(null);

  const labelClr = useColorModeValue("gray.700", "gray.300");
  const inputBg   = useColorModeValue("white", "gray.700");
  const borderClr = useColorModeValue("gray.200", "gray.600");

  const loadFiles = useCallback(async () => {
    setIsLoading(true);
    const res = await fetch_big_files();
    setIsLoading(false);
    if (res?.success) {
      setFiles(Array.isArray(res.data) ? res.data : []);
    } else {
      setFiles([]);
    }
  }, []);

  useEffect(() => {
    loadFiles();
  }, []);

  const handleUpload = async () => {
    if (!docname.trim()) { toast.info("Please enter document name"); return; }
    if (!doctype.trim()) { toast.info("Please enter document type"); return; }
    if (!docfile)        { toast.info("Please select a file"); return; }

    const body = new FormData();
    body.append("action", "upload");
    body.append("userid", "2");
    body.append("docname", docname);
    body.append("doctype", doctype);
    body.append("docfile", docfile);

    const res = await upload_big_file(body, setUploadLoading);
    if (res?.success) {
      setDocname("");
      setDoctype("");
      setDocfile(null);
      onClose();
      loadFiles();
    }
  };

  const handleClose = () => {
    setDocname("");
    setDoctype("");
    setDocfile(null);
    onClose();
  };

  return (
    <Container h={"full"} w={"full"} maxW={"full"}>
      <HeadingLayout
        title={"Big File Upload"}
        sNot={true}
        btnNot={true}
        totalCount={files.length}
      />

      <Flex justify={"flex-end"} mb={3}>
        <CustomButton title={"Add New File"} onClick={onOpen} />
      </Flex>

      {isLoading ? (
        <Loader />
      ) : files.length === 0 ? (
        <Center borderRadius={10}>
          <Image src="/no-data.jpg" h={"md"} objectFit={"contain"} />
        </Center>
      ) : (
        <TableView
          headData={["S.No.", "Doc Name", "Doc Type", "File", "Uploaded On"]}
          body={files.map((v, i) => (
            <Tr key={i}>
              <Td textAlign={"center"}>{i + 1}</Td>
              <Td textAlign={"center"}>{v?.docname || v?.doc_name || "-"}</Td>
              <Td textAlign={"center"}>{v?.doctype || v?.doc_type || "-"}</Td>
              <Td textAlign={"center"}>
                {v?.docfile || v?.doc_file || v?.file_url ? (
                  <Link
                    href={v?.docfile || v?.doc_file || v?.file_url}
                    isExternal
                    color={"blue.400"}
                    fontWeight={"semibold"}
                  >
                    View / Download
                  </Link>
                ) : (
                  "-"
                )}
              </Td>
              <Td textAlign={"center"}>{v?.created_at || v?.date || "-"}</Td>
            </Tr>
          ))}
        />
      )}

      {/* Upload Modal */}
      <Modal isOpen={isOpen} onClose={handleClose} isCentered size={"md"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add New File</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction={"column"} gap={4}>
              <Flex direction={"column"} gap={1}>
                <FormLabel mb={0} color={labelClr}>
                  Document Name
                </FormLabel>
                <Input
                  placeholder="Enter document name"
                  value={docname}
                  onChange={(e) => setDocname(e.target.value)}
                  bg={inputBg}
                  borderColor={borderClr}
                />
              </Flex>

              <Flex direction={"column"} gap={1}>
                <FormLabel mb={0} color={labelClr}>
                  Document Type
                </FormLabel>
                <Input
                  placeholder="e.g. pdf, txt, docx"
                  value={doctype}
                  onChange={(e) => setDoctype(e.target.value)}
                  bg={inputBg}
                  borderColor={borderClr}
                />
              </Flex>

              <Flex direction={"column"} gap={1}>
                <FormLabel mb={0} color={labelClr}>
                  Select File
                </FormLabel>
                <Input
                  type="file"
                  p={1}
                  bg={inputBg}
                  borderColor={borderClr}
                  onChange={(e) => setDocfile(e.target.files[0] || null)}
                />
                {docfile && (
                  <Text fontSize={"sm"} color={"gray.500"} mt={1}>
                    Selected: {docfile.name}
                  </Text>
                )}
              </Flex>
            </Flex>
          </ModalBody>

          <ModalFooter gap={3}>
            <CustomButton bg={"gray"} title={"Cancel"} onClick={handleClose} />
            <CustomButton
              title={"Upload"}
              loading={uploadLoading}
              onClick={handleUpload}
            />
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default BigFiles;
